import React, { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error capturado por ErrorBoundary:", error, errorInfo);
    // Redirige después de 1 segundo
    setTimeout(() => {
      window.location.href = "/404";
    }, 1000);
  }

  render() {
    if (this.state.hasError) {
      return <div>Redirecting...</div>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;